function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M247.9 106.1h-42.5v113.5H78.2V106.1H42.8V63.9h51.6c7.9 26.5 35.7 41.6 62.2 33.7 16.2-4.8 28.9-17.5 33.7-33.7H248l-.1 42.2zM7.1 35.4v99.1h42.6V248H234V134.6h42.5V35.4H163.8v14.2c0 11.9-9.6 21.5-21.5 21.5s-21.5-9.6-21.5-21.5l-.1-14.2H7.1z"
})));